<template>
  <b-card title="Service">
    <!-- Barre de recherche et bouton "Ajouter Service" -->
    <div class="custom-search d-flex justify-content-end mb-2">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Rechercher :</label>
          <b-form-input v-model="searchTerm" placeholder="Recherche" type="text" class="d-inline-block mr-1" />
          <b-button variant="primary" @click="openAddModal">
            <span>Ajouter Service</span>
          </b-button>
        </div>
      </b-form-group>
    </div>

    <!-- Tableau des services -->
    <vue-good-table :columns="columns" :rows="rows" :rtl="direction"
      :search-options="{ enabled: true, externalQuery: searchTerm }"
      :pagination-options="{ enabled: true, perPage: pageLength }">

      <template v-slot:table-row="props">
        <!-- Colonne : Nom du Service -->
        <template v-if="props.column.field === 'name'">
          <span class="text-nowrap">{{ props.row.name }}</span>
        </template>

        <!-- Colonne : Direction -->
        <template v-else-if="props.column.field === 'directions'">
          <span class="text-nowrap">{{ props.row.directions.name }}</span>
        </template>

        <!-- Colonne : Péage/Siège -->
        <template v-else-if="props.column.field === 'toll'">
          <b-badge :variant="statusVariants(props.row.toll)">
            {{ props.row.toll ? 'Péage' : 'Siège' }}
          </b-badge>
        </template>

        <!-- Colonne : Statut -->
        <template v-else-if="props.column.field === 'active'">
          <b-badge :variant="statusVariant(props.row.active)">
            {{ props.row.active ? "Actif" : "Désactivé" }}
          </b-badge>
        </template>

        <!-- Colonne : Actions -->
        <template v-else-if="props.column.field === 'action'">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template v-slot:button-content>
              <more-vertical-icon size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item @click="openEditModal(props.row)">
              <edit-2-icon class="mr-50" />
              Modifier
            </b-dropdown-item>

            <b-dropdown-item v-if="props.row.isUsed"
              @click="deactivateServicesHandler(props.row.id, !props.row.active)">
              <ToggleLeftIcon class="mr-50" />
              {{ props.row.active ? "Désactiver" : "Activer" }}
            </b-dropdown-item>

            <b-dropdown-item v-else @click="deleteServiceHandler(props.row.id)">
              <trash-icon class="mr-50" />
              Supprimer
            </b-dropdown-item>
          </b-dropdown>
        </template>

        <template v-else>
          {{ props.formattedRow[props.column.field] }}
        </template>
      </template>

      <template v-slot:pagination-bottom="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">Afficher</span>
            <b-form-select
            v-model="pageLength"
            :options="[3, 5, 10, 25, 50, 100, 200]"
            class="mx-1"
              @input="value => props.perPageChanged({ currentPerPage: value })" />
            <span class="text-nowrap">de {{ props.total }} Données</span>
          </div>
          <b-pagination
          :value="1"
          :total-rows="props.total"
          :per-page="pageLength"
          first-number
           last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            @input="value => props.pageChanged({ currentPage: value })">
            <template #prev-text>
              <chevron-left-icon size="18" />
            </template>
            <template #next-text>
              <chevron-right-icon size="18" />
            </template>
          </b-pagination>
        </div>
      </template>

    </vue-good-table>

    <!-- Pagination -->


    <b-modal v-model="isModalActive" :title="modalTitle"  @hidden="resetModal" @hide="resetModal"
      cancelTitle="Fermer" cancel-variant="outline-secondary" @ok="handleOk">
      <b-form ref="form" @submit.stop.prevent="handleSubmit">

        <b-form-group       ref="nameinput" :state="nameState" label="Intitulé"  label-for="name-input" invalid-feedback="Ce champ est requis.">
          <b-form-input  id="name-input" v-model="currentService.name" :state="nameState" placeholder="Nom du Service" required/>
          <b-form-invalid-feedback />

        </b-form-group>

        <b-form-group ref="directioninput" :state="directionsState" label="Direction"   label-for="directions-input" invalid-feedback="Ce champ est requis.">
          <v-select  id="direction-input" v-model="currentService.directions.id" label="name" :options="directionsAll" :state="directionsState" :reduce="direction => direction.id"  required/>
          <b-form-invalid-feedback />

        </b-form-group>

        <b-form-group>
          <b-form-checkbox v-model="currentService.toll" switch>
            Péage Actif
          </b-form-checkbox>
        </b-form-group>

      </b-form>
    </b-modal>
  </b-card>
</template>

<script>
// Importations nécessaires
import {
  BCard, BFormGroup, BFormInput, BButton, BFormSelect, BDropdown, BDropdownItem, BPagination, BModal, BFormCheckbox,
} from 'bootstrap-vue';
import { VueGoodTable } from 'vue-good-table';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {
  MoreVerticalIcon, Edit2Icon, TrashIcon,ToggleLeftIcon, ChevronLeftIcon,
  ChevronRightIcon,
} from 'vue-feather-icons';
import {
  allServices, saveServices, deleteServices, updateServices, updateDisabledService,
} from '@/services/ServicesService';
import { allDirections, getAllDirectionsByActive } from '@/services/DirectionsService';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { required } from '@validations'

export default {
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    BButton, BDropdown, BDropdownItem,  BModal, BFormCheckbox,
    BFormSelect,
    BPagination,
    vSelect,
    VueGoodTable,
    MoreVerticalIcon, Edit2Icon, TrashIcon,
    ToggleLeftIcon,
    ChevronLeftIcon,
  ChevronRightIcon,
    //eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      rows: [],
      searchTerm: '',
      pageLength: 10,
      isModalActive: false,
      isEditMode: false,
      modalTitle: '',
      currentService: { name: '', directions: { id: null }, toll: false },
      directionsAll: [],
      required,
      active: true,
      columns: [
        { label: 'Nom du Service', field: 'name' },
        { label: 'Direction', field: 'directions' },
        { label: 'Site', field: 'toll' },
        { label: 'Statut', field: 'active' },
        { label: 'Actions', field: 'action' },
      ],
      directionsState: null,
      nameState:null,
    };
  },
  computed: {
    statusVariant() {
      return status => (status ? 'light-primary' : 'light-danger');
    },
    statusVariants() {
      return status => (status ? 'light-primary' : 'light-success');
    },
    direction() {
      return this.dir;
    },
  },
  methods: {
    checkFormValidity() {
      // Vérification des champs et mise à jour des états
      this.nameState = this.currentService.name.trim() === "" ? false : null;
      this.directionsState = !this.currentService.directions.id ? false : null;

      // Retourne `false` si un des champs est invalide
      return this.nameState === null && this.directionsState === null;
    },
    validateName() {
      if (!this.currentService.name) return


      const forbiddenPatterns = [
            /<\s*\/?\s*[a-zA-Z][a-zA-Z0-9_-]*\s*.*?>/i,
            /<\s*script/i,
            /<\s*style/i,
            /on\w+\s*=/i,
            /(javascript|data|vbscript):/i,
            /(\$\{[^}]*\}|\{\{[^}]*\}\}|#\{[^}]*\})/,
            /(%3C|%3E|&#\d+;|&#x[0-9a-fA-F]+;|\\u[0-9a-fA-F]{4}|\\x[0-9a-fA-F]{2})/i,
          /<!--|--\>/
      ];



      return !forbiddenPatterns.some(pattern => pattern.test(this.currentService.name));

    },
    replaceString() {
      return  this.currentService.name.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    },
    async fetchData() {
      try {
        this.directionsAll = await getAllDirectionsByActive(this.active);
        this.rows = await allServices();
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    openAddModal() {
      this.isEditMode = false;
      this.modalTitle = 'Ajouter Service';
      this.isModalActive = true;
    },
    openEditModal(service) {
      this.isEditMode = true;
      this.modalTitle = 'Modifier Service';
      this.currentService = { ...service };
      this.isModalActive = true;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    async handleSubmit() {
      if (!this.checkFormValidity() || !this.validateName()) return;
      // this.currentService.name = this.replaceString();
      try {
        if (this.isEditMode) {
          const updatedService = await updateServices(this.currentService.id, this.currentService);
          const index = this.rows.findIndex(row => row.id === updatedService.id);

          if (index !== -1) this.$set(this.rows, index, updatedService);
          this.showToast("Service modifié avec succès.", "success");
          this.resetModal();
          this.isModalActive = false;
        } else {
          const newService = await saveServices(this.currentService);

          this.rows.push(newService);
          this.showToast("Service ajouté avec succès.", "success");
          this.resetModal();
        }
        // this.isModalActive = false;
      } catch (error) {
        console.error('Error saving service:', error);
      }
    },
    async deleteServiceHandler(serviceId) {
      try {
        await deleteServices(serviceId);
        this.rows = this.rows.filter(row => row.id !== serviceId);
        this.showToast("Service supprimé avec succès.","success");

      } catch (error) {
        console.error('Error deleting service:', error);
        this.showToast("Échec lors de la suppression.", "danger");

      }
    },
    async deactivateServicesHandler(serviceId, isActive) {
      try {
        // Appel au service pour mettre à jour l'état actif/inactif
        const updatedService = await updateDisabledService(serviceId, { active: isActive });

        // Trouver le service correspondant dans la liste et le mettre à jour
        const serviceIndex = this.rows.findIndex(row => row.id === serviceId);
        if (serviceIndex !== -1) {
          this.$set(this.rows, serviceIndex, updatedService);
        }

        // Afficher un message de confirmation
        this.showToast(`Service ${isActive ? 'activé' : 'désactivé'} avec succès.`);
      } catch (error) {
        console.error('Erreur lors de la mise à jour du statut du service:', error);
        this.showToast(`Échec de la mise à jour du statut.`,"danger");
      }
    },
    showToast(message,color) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: "CheckCircleIcon",
          variant: color,
        },
      });
    },
    resetModal() {
      this.currentService = { name: '', directions: { id: null }, toll: false };
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style lang="scss" scoped>
@import '~vue-good-table/dist/vue-good-table.css';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
